module.exports = __webpack_public_path__ + "img/tab01.468b35be.png";